import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { Button, Modal, message } from 'ant-design-vue'

import '@/common/filters'

moment.locale('zh-cn')

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(Button)
Vue.use(Modal)
Vue.prototype.$message = message
